import axios from 'axios';

import { getConfig } from '../common';

export const BASE_SERVICE_PATH = 'retail-insights/api';

export interface OpaSubscription {
  result: Subscription;
}

interface Subscription {
  access: string;
  restrictions: RetailSubscription[];
}

export interface RetailSubscription {
  country: string;
  retailer: number;
  itemGroup: string | null;
}

export interface OPARetailClientSubscriptions {
  retailInsights: RetailSubscription[];
  retailHitlistStandard: RetailSubscription[];
}

export interface RetailMarkets {
  retailInsights: string[];
  retailHitlistStandard: string[];
}

export const getRIClientSubscription = async (token: string): Promise<OpaSubscription> => {
  try {
    const config = getConfig();
    const headers = { Authorization: `Bearer ${token}` };
    const { data } = await axios.get<OpaSubscription>(`${config.BASE_URL}${BASE_SERVICE_PATH}/opa/v2/subscription`, {
      headers,
    });
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

export const getRHSClientSubscription = async (token: string): Promise<OpaSubscription> => {
  try {
    const config = getConfig();
    const headers = { Authorization: `Bearer ${token}` };
    const { data } = await axios.get<OpaSubscription>(
      `${config.BASE_URL}${BASE_SERVICE_PATH}/opa/v2/hitlists_standard_subscription`,
      {
        headers,
      }
    );
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

export const getRetailClientSubscription = async (token: string): Promise<OPARetailClientSubscriptions> => {
  const retailInsightsOPA = await getRIClientSubscription(token);
  const retailHitlistStandardOPA = await getRHSClientSubscription(token);

  return {
    retailInsights: retailInsightsOPA?.result?.restrictions ?? [],
    retailHitlistStandard: retailHitlistStandardOPA?.result?.restrictions ?? [],
  };
};
